import React, { Component } from 'react'
import styled from 'styled-components'
import { Button, Colors, Title1 } from 'advenio-components'
import PropTypes from 'prop-types'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
`
const Title = styled(Title1)`
  margin-bottom: 32px;
`
const ConsumeAmountContainer = styled.div`
  display: flex;
  align-items: center;
  height: 80px;
  width: 100%;
  background-color: #f2f2f2;
`
const Info = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  width: 50%;
`
const ConsumeAmountText = styled.span`
  margin-right: 8px;
  color: ${Colors.blue500};
`
const ConfirmButton = styled(Button)`
  margin-top: 32px;
  color: ${Colors.white500};
  background-color: ${Colors.blue500};
`

const ConsumeAmountRow = ({ label, value }) => (
  <ConsumeAmountContainer>
    <Info>
      <span>{label}:</span>
    </Info>
    <Info>
      <ConsumeAmountText>{value}</ConsumeAmountText>
    </Info>
  </ConsumeAmountContainer>
)

ConsumeAmountRow.propTypes = {
  /** The label describing what the value represents. E.g. Sólidos */
  label: PropTypes.string.isRequired,
  /** The value describing what was consumed */
  value: PropTypes.string.isRequired,
}

class ConfirmMeal extends Component {
  state = {
    eat: '',
  }

  componentWillMount() {
    const { info } = this.props
    let eat = ''

    switch (info && info.eat) {
      case '1':
      default:
        eat = 'Nada'
        break
      case '2':
        eat = 'Casi Nada'
        break
      case '3':
        eat = 'La Mitad'
        break
      case '4':
        eat = 'Casi Todo'
        break
      case '5':
        eat = 'Todo'
        break
    }

    this.setState({ eat })
  }

  handleConfirmMeal = () => {
    const { activityId, category, info, postFinishActivity } = this.props

    const params = {
      type_id: category,
      total_drink: info.drink,
      total_eat: info.eat,
      consumable_ids: info.extras,
    }

    if (activityId) {
      postFinishActivity(activityId, params)
    }
  }

  render() {
    const { child, info, loading } = this.props
    let extraCharges = `${info.extras.length} Artículo`

    if (info.extras.length !== 1) {
      extraCharges += 's'
    }

    return (
      <Container>
        <Title>
          {`Confirmar lo que consumió ${child.first_name} ${child.last_name_paternal} :`}
        </Title>
        <ConsumeAmountRow label="Líquidos" value={info.drink && `${info.drink} oz`} />
        <ConsumeAmountRow label="Sólidos" value={this.state.eat} />
        <ConsumeAmountRow label="Cargos Extra" value={extraCharges} />
        <ConfirmButton
          small
          onClick={this.handleConfirmMeal}
          loading={loading}
        >
          Confirmar
        </ConfirmButton>
      </Container>
    )
  }
}

ConfirmMeal.propTypes = {
  /** The ID of the activity to be completed */
  activityId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  /** The category of the activity being registered */
  category: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  /** The child to whom the activity will be registered */
  child: PropTypes.object,
  /** Extra information to be submitted to the API with the activity when completing */
  info: PropTypes.object,
  /** Loading flag */
  loading: PropTypes.bool,

  /** Callback function to finish the activity */
  postFinishActivity: PropTypes.func.isRequired,
}

ConfirmMeal.defaultProps = {
  category: '',
  child: {},
  info: {},
  loading: false,
}

export default ConfirmMeal



// WEBPACK FOOTER //
// ./src/Components/Activity/ConfirmMeal.jsx